import { useStoreState } from '@/stores/store';
import React, { useState } from 'react';
import { View } from 'react-native';
import { Text } from '@/components/Text';
import { Row } from './Row';
import { TextRow } from './TextRow';
import { styles } from './styles';
import { Button } from '@/components/ui/therapist/Button';
import { Modal } from '../ui/therapist/Modal';

export function Selected({
  title,
  data,
  dataCount,
  onPress,
  headerPress,
  onButtonPress,
  isTextSet,
}) {
  const [isDemoTherapistVisible, setIsDemoTherapistVisible] = useState(false);
  const { isTherapistDemo } = useStoreState((store) => store);
  const checkIfInDemoTherapist = () => {
    if (isTherapistDemo) {
      setIsDemoTherapistVisible(true);
    } else {
      onButtonPress();
    }
  };

  return (
    <View style={styles.containerItem}>
      <Modal
        isVisible={isDemoTherapistVisible}
        title="In der Demo nicht möglich"
        confirmActionButton={
          <Button
            label="OK"
            look="primary"
            onPress={() => setIsDemoTherapistVisible(false)}
          />
        }
        onClose={() => setIsDemoTherapistVisible(false)}
      >
        <Text style={{ fontSize: 18 }}>
          Registrieren Sie sich bei neolexon, um Ihre eigenen Patient:innen und
          Übungssets zu erstellen.
        </Text>
      </Modal>
      <View style={styles.containerItemHeader}>
        <View style={styles.containerItemHeaderText}>
          <Text style={styles.title}>{title || 'Selected'}</Text>
          <Text style={styles.titleSize}> {dataCount}</Text>
        </View>
        <Button onPress={headerPress} look="danger" icon="trash" />
      </View>
      <View style={styles.containerItemBody}>
        {data.map((eachData) => {
          if (isTextSet) {
            const { title, _id, simpleBody, textLength } = eachData;
            const isSelected = data.includes(_id);

            return (
              <React.Fragment key={_id + textLength}>
                <TextRow
                  isSelected={isSelected}
                  wholeObject={eachData}
                  bodyText={simpleBody}
                  hasTags
                  textLength={textLength}
                  title={title}
                  tags={[]}
                  onPress={onPress}
                  insideSelected
                />
                <View style={styles.seperator} />
              </React.Fragment>
            );
          } else {
            const { _id, pictures, print } = eachData;
            const hasImage = pictures.length > 0;
            const title = print;
            return (
              <React.Fragment key={_id}>
                <Row
                  wholeObject={eachData}
                  isTextSet={false}
                  hasImage={hasImage}
                  hasTags={false}
                  imageURL={pictures[0].appimage_url}
                  title={title}
                  insideSelected
                  tags={[]}
                  onPress={onPress}
                />
                <View style={styles.seperator} />
              </React.Fragment>
            );
          }
        })}
        {data.length > 0 ? (
          <Button
            style={{ margin: 10, alignSelf: 'flex-start' }}
            onPress={checkIfInDemoTherapist}
            label="Speichern"
          />
        ) : null}
      </View>
    </View>
  );
}
